import {Injectable, Inject} from 'ng-metadata/core';

import {getVid,getInstitutionCode} from '../../appConfig/appConfigForward';
import {JwtUtilService} from '../../security/jwtUtil.service';
import {beacon, PrimolyticsService} from "../../analytics/primolytics.service";

@Injectable()
export class BrowseSearchService {
    private _browseResult = [];
    private _searchParams = [];
    private _backTerm:string;
    private _lastPnxIndex:string;
    private _inProgress:boolean=false;
    private _nextTerm:string;
    private _numOfUsedTerm:string;
    private _searchedScope: string;
    private _offset: number;
            constructor(@Inject('$http') private $http : ng.IHttpService,private jwtUtilService: JwtUtilService,
                        private primolyticsService: PrimolyticsService,
                        @Inject('restBaseURLs') private restBaseURLs){}

    public resetParams(){
        this._backTerm = undefined;
        this._nextTerm = undefined;
        this._lastPnxIndex = undefined;
        this._numOfUsedTerm = undefined;
        this._browseResult = [];
        this._searchParams= [];
        this._offset =0;
    }




    public onCampus():string{
        if(this.jwtUtilService.getDecodedToken().onCampus == 'true'){
            return "true";
         }
        else{
            return "false"
        }

    }
    public isSignedIn():string{
        if (this.jwtUtilService.isSignedIn()){
             return "true";
        }
        return "false";
     }



    @beacon({'p':'search', 'op': 'browse'})
    public getSearchJson(fn:string ="BrowseSearch", searchWord:string ="" , browseField:string ,
                         callnumberBack:number = -1, innerPnxIndex:number = -1, numOfUsedTerms:number = -1,isBack:boolean = false, offset:number){

    	let viewId:string = getVid();
	    let onCamp:string = this.onCampus();
	    let loggedIn:string =this.isSignedIn();
	    let instCode:string = getInstitutionCode();
	    let group:string = this.jwtUtilService.getDecodedToken().userGroup;
	    
        if(searchWord == "" && !browseField.startsWith("callnumber")){
            searchWord = "!";
        }

	    let config = {"params":{"vid":viewId,
                            "onCamp":onCamp,
                            "loggedIn":loggedIn,
                            "instCode":instCode,
                            "group" : group,
                            "callnumberBack":callnumberBack,
                            "innerPnxIndex":innerPnxIndex,
                            "numOfUsedTerms":numOfUsedTerms,
                            "isBack":isBack,
                            "fn":fn,
                            "searchWord":searchWord,
                            "browseField":browseField,
                            "offset":offset}};
        this._inProgress = true;
        let promise = this.$http.get(this.restBaseURLs.browse+"/browseSearch",config);
        this._searchedScope= browseField;
        promise.then((response)=>{
            this._browseResult = response.data.nexdPresentedValues;
            this.updateFields(response.data);
            this._inProgress = false;
        });
        return true;

     }
     get inProgress(){
                return this._inProgress;
     }

     public updateFields(data):void{
         this._backTerm = data['backTerm'];
         this._nextTerm = data['nextTerm'];
         this._lastPnxIndex = data['lastPnxIndex'];
         this._numOfUsedTerm = data['numOfUsedTerm']
         this._offset = data['offset'];
     }


     get lastPnxIndex(){
         return this._lastPnxIndex;
     }

     get numOfUsedTerm(){
         return this._numOfUsedTerm;
     }

    get nextTerm(){
        return this._nextTerm;
    }

     get backTerm(){
         return this._backTerm;
     }

    get browseResult(){
        return this._browseResult;
    }

    get searchedScope(): string{
        return this._searchedScope;
    }

    get browseSearchParams(){
        return this._searchParams;
    }

    get offset(){
        if(this._offset)
            return this._offset;
        return 0;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/browse/browseSearch.service.ts